import { type ReactNode } from 'react'
import { Dropdown, DropdownTitle, DropdownItem } from '@/components/Dropdown'
import { Icon } from '@/components/Icon'
import styles from './TableControls.module.css'

export interface TableControlsProps {
  isGlobalInventory: boolean
  onAddInventoryItem: () => void
  button: ReactNode
}

export function TableControls({
  button,
  isGlobalInventory,
  onAddInventoryItem,
}: TableControlsProps) {
  return (
    <>
      <Dropdown autoDismiss position="bottom-end" button={button}>
        <div className={styles.tableControlsContainer}>
          <DropdownTitle>Menu</DropdownTitle>
          <TableControlsItem
            onPress={onAddInventoryItem}
            icon={
              <Icon
                className={styles.tableControlsItemIcon}
                name="add"
                size={24}
              />
            }
          >
            {isGlobalInventory ? 'Add service item' : 'Add workspace item'}
          </TableControlsItem>
        </div>
      </Dropdown>
    </>
  )
}

interface TableControlsItemProps {
  children: ReactNode
  icon: ReactNode
  active?: boolean
  onPress?: () => void
}

function TableControlsItem({
  children,
  icon,
  active,
  onPress,
}: TableControlsItemProps) {
  return (
    <DropdownItem icon={icon} active={active} onPress={onPress}>
      {children}
    </DropdownItem>
  )
}
